import { Image, Input } from '@chakra-ui/react'
import React, { FC } from 'react'
Image
interface Search {
  term: string
  search(value: string): void
}

const SearchSlow: FC<Search> = ({ term, search }) => {
  return (
    <>
      <Image src="./img/search_icon.svg" alt="" className="serch_icon_stakk" />
      <Input type="text" placeholder="Search Token Pair" onChange={(e) => search(e.target.value)} value={term} />
    </>
    // <div className="flex items-center gap-4 w-[350px] sm:w-auto">
    //   <div className="focus-within:ring-2 ring-blue flex flex-grow gap-2 items-center rounded border border-dark-800 bg-dark-900 bg-opacity-50 py-2 px-3 w-full sm:w-auto">
    //     <SearchIcon strokeWidth={3} width={20} height={20} />
    //     <input
    //       className="bg-transparent text-high-emphesis w-full placeholder:text-low-emphesis"
    //       placeholder={i18n._(t`Search by token or pair`)}
    //       onChange={(e) => search(e.target.value)}
    //       value={term}
    //     />
    //   </div>
    // </div>
  )
}

export default SearchSlow
